<template>
    <div>
        <b-jumbotron class="dense">
            <b-container>
                <h1>Welcome to VPNla</h1>
                <hr />
                <p>
                    Want a full Internet experience when trapped inside a
                    firewall?
                </p>
                <p>Just use VPNla~</p>
                <hr />
                <b-button-group size="lg" v-if="loggedIn">
                    <b-button variant="primary" to="/dashboard"
                        >Go to your Dashboard</b-button
                    >
                </b-button-group>
                <b-button-group size="lg" v-else>
                    <b-button variant="primary" to="/login">Log in</b-button>
                    <b-button variant="secondary" to="/register">
                        Create an account
                    </b-button>
                </b-button-group>
            </b-container>
        </b-jumbotron>

        <b-jumbotron>
            <b-container>
                <b-row cols="1" cols-sm="2">
                    <b-col>
                        <h1 class="mb-3">Exceptional Speed</h1>
                        <p>We <b>don't</b> limit network speeds.</p>
                        <p>
                            Our service is hosted in a state-of-the-art
                            datacentre in London, ensuring the best network
                            routes and the lowest latency.
                        </p>
                    </b-col>
                    <b-col>
                        <b-img
                            src="api/files/speedtest.png"
                            alt="From speedtest.net, test conducted from our server."
                            fluid
                            rounded
                        />
                    </b-col>
                </b-row>
            </b-container>
        </b-jumbotron>

        <b-jumbotron>
            <b-container>
                <b-row cols="1" cols-sm="2">
                    <b-col>
                        <h1 class="mb-3">Top Security</h1>
                        <p>
                            Powered by the industry-leading VPN,
                            <a href="https://wireguard.com">WireGuard</a>.
                        </p>
                        <blockquote>
                            <p>
                                "Can I just once again state my love for
                                [WireGuard] and hope it gets merged soon? Maybe
                                the code isn't perfect, but I've skimmed it, and
                                compared to the horrors that are OpenVPN and
                                IPSec, it's a work of art."
                            </p>
                            <p>
                                --- Linus Torvalds, on the Linux Kernel Mailing
                                List
                            </p>
                        </blockquote>
                    </b-col>
                    <b-col>
                        <b-img
                            src="api/files/wgcli.png"
                            alt="Screenshot of the WireGuard backend on our servers, credentials cropped out."
                            fluid
                            rounded
                        />
                    </b-col>
                </b-row>
            </b-container>
        </b-jumbotron>

        <b-jumbotron>
            <b-container>
                <b-row cols="1" cols-sm="2">
                    <b-col>
                        <h1 class="mb-3">Cross Platform</h1>
                        <p>Available on all major OSes.</p>
                        <p>
                            All clients are free and open-source, to ensure
                            maximum security and greatest code quality.
                        </p>
                    </b-col>
                    <b-col>
                        <router-link to="apps"
                            ><b-img
                                src="api/files/crossplatform.png"
                                to="apps"
                                fluid
                                rounded
                        /></router-link>
                    </b-col>
                </b-row>
            </b-container>
        </b-jumbotron>
    </div>
</template>

<script>
    import Cookies from 'js-cookie'

    export default {
        computed: {
            loggedIn() {
                return !!Cookies.get('auth')
            }
        }
    }
</script>